<template>
  <b-form-group class="d-inline-block" :label="inputLabel" :label-for="inputId">
    <b-form-select
      :id="inputId"
      :value="value"
      @input="$emit('input', $event)"
      :options="customOptions"
    ></b-form-select>
  </b-form-group>
</template>
<script>
export default {
  emits: ["getSelectedOption"],
  props: {
    inputLabel: {
      type: String,
      default: "انتخاب کنید",
    },
    inputId: {
      type: String,
      default: "selectForm",
    },
    customOptions: {
      type: [Array],
      required: true,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    selectedOption: {
      handler(val) {
        this.$emit("getSelectedOption", val);
      },
    },
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  components: {
    BFormGroup,
    BFormSelect,
  },
};
import { BFormGroup, BFormSelect } from "bootstrap-vue";
</script>
